import { render, staticRenderFns } from "./ContractorGSTRetained.vue?vue&type=template&id=0f2cd84c"
import script from "./ContractorGSTRetained.vue?vue&type=script&lang=js"
export * from "./ContractorGSTRetained.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports